import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'

import { ValidationProposalModalFooter, ValidationProposalModalText, StyleSiteName } from '../style'

const SiteProposalConfirmation = ({ toggleModal, proposeSite, name }) => {
  const closeModal = () => {
    toggleModal(false)
  }
  return (
    <div>
      <ValidationProposalModalText>
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        Are you sure that you want to propose the assessment for <StyleSiteName>{name}</StyleSiteName> site ? This action cannot be undone.
      </ValidationProposalModalText>
      <ValidationProposalModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="primary" onClick={() => {
          proposeSite()
          closeModal()
        }}>
          <FormattedMessage id="propose" />
        </Button>
      </ValidationProposalModalFooter>
    </div>
  )
}

export default SiteProposalConfirmation
